export const BASE_URL = import.meta.env.VITE_API_URL;
export const GOOGLE_MAPS_BASE_URL = 'https://maps.googleapis.com/maps/api/';
export const ADS_API_BASE_URL = 'https://europe-west2-connected-railway.cloudfunctions.net/';
export const LANDING_URL = import.meta.env.VITE_LANDING_URL;

export const RECAPTCHA_V2_API_KEY = import.meta.env.VITE_CAPTCHA_V2_KEY;
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

// RevenueCat configuration
export const REVENUECAT_WEB_BILLING_API_KEY = import.meta.env.VITE_REVENUECAT_WEB_BILLING_API_KEY;
export const REVENUECAT_APP_ID = import.meta.env.VITE_REVENUECAT_APP_ID;
export const REVENUECAT_PAYMENT_LINK = import.meta.env.VITE_REVENUECAT_PAYMENT_LINK;
export const REVENUECAT_PRODUCT_LINK = import.meta.env.VITE_REVENUECAT_PRODUCT_LINK;

// Stripe configuration
export const STRIPE_SEAT_PURCHASE_URL = import.meta.env.VITE_STRIPE_SEAT_PURCHASE_URL;

export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const GET_STREAM_DATA_KEY = 'get_stream_data';
export const GO_TO_INVITE_MEMBERS = 'got-to-invite-members';
export const UNAUTHORIZED_REDIRECT = 'unauthorized-redirect';

export const RECAPTCHA_VERSION_HEADER = 'recaptcha-version';
export const RECAPTCHA_TOKEN_HEADER = 'recaptcha';
export const RECAPTCHA_MAX_TRY_LIMIT = 10;
export const RECAPTCHA_BLOCK_TIME = 10;

export const RELEASE_DATE = '2023-12-10';
export const PHONE_NUMBER = '0800 112 5012';
export const EMAIL = 'hello@connectedappsltd.com';

export const INAPPROPRIATE_CONTENT_ERROR = 'file_contains_inappropriate_content';

export const RECRUITER_DEACTIVATED = 442;
export const USER_UNAUTHORIZED = 401;
export const REFRESH_TOKEN_EXPIRED = 440;
export const EXPIRED_TOKEN_MESSAGE_KEY = 'invalid_or_expired_refresh_token';
